import { attentiveClient } from './providers/attentive/attentive.client';
import { googleAdsClient } from './providers/google/googleAds.client';
import { googleAnalyticsClient } from './providers/google/googleAnalytics.client';
import { metaClient } from './providers/meta/meta.client';
import { pinterestClient } from './providers/pinterest/pinterest.client';
import { snapchatClient } from './providers/snapchat/snapchat.client';
import { tiktokClient } from './providers/tiktok/tiktok.client';
import { tinuitiClient } from './providers/tinuiti/tinuiti.client';
import { CookieBotConsentType } from './socialMediaMarketing.model';
var SMMSProvider;
(function (SMMSProvider) {
    SMMSProvider["Pinterest"] = "Pinterest";
    SMMSProvider["GoogleAds"] = "GoogleAds";
    SMMSProvider["GoogleAnalytics"] = "GoogleAnalytics";
    SMMSProvider["Meta"] = "Meta";
    SMMSProvider["Tiktok"] = "Tiktok";
    SMMSProvider["Snapchat"] = "Snapchat";
    SMMSProvider["Attentive"] = "Attentive";
    SMMSProvider["Tinuiti"] = "Tinuiti";
})(SMMSProvider || (SMMSProvider = {}));
export const pixelClients = {
    Pinterest: {
        client: pinterestClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
    GoogleAds: {
        client: googleAdsClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
    GoogleAnalytics: {
        client: googleAnalyticsClient,
        requiredConsent: CookieBotConsentType.statistics,
    },
    Meta: {
        client: metaClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
    Tiktok: {
        client: tiktokClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
    Snapchat: {
        client: snapchatClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
    Attentive: {
        client: attentiveClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
    Tinuiti: {
        client: tinuitiClient,
        requiredConsent: CookieBotConsentType.marketing,
    },
};
